<div [ngStyle]="{'height': 'inherit', 'display':'flex', 'flex-direction':'column'}">
  <div class="dx-fieldset" [ngStyle]="{'margin': '20px 30px'}">
    <div class="dx-field">
      <div class="dx-field-label">{{ 'Produktstatus filtern' | translate }}</div>
      <div class="dx-field-value">
        <dx-switch [(value)]="exportParameter.productStatesFilter.useFilter" (onValueChanged)="loadStatesIfNeeded()"></dx-switch>
      </div>
    </div>
  </div>
  <div *ngIf="exportParameter.productStatesFilter.useFilter" [ngStyle]="{'height': '100%', 'overflow':'hidden'}">
    <div *ngIf="isStateFilterLoaded==false" style="top: 30%;">
      <div class="loader"></div>
    </div>
    <div *ngIf="isStateFilterLoaded==true" class="{{fullScreen ? '' : 'maxHeight'}}" [ngStyle]="{'margin-top': '-20px', 'height': 'inherit'}">
      <dx-tree-list [(dataSource)]="catalogProductStates"
                    [(selectedRowKeys)]="exportParameter.productStatesFilter.filterKey"
                    [ngStyle]="{'height': 'inherit'}"
                    keyExpr="name"
                    [rootValue]="rootValue">
        <dxo-search-panel [visible]="true"></dxo-search-panel>
        <dxo-selection mode="multiple" recursive="true"></dxo-selection>
        <dxo-scrolling preloadEnabled="true" useNative="true"></dxo-scrolling>
        <dxi-column dataField="name" caption="{{ 'ProduktStatus' | translate }}"></dxi-column>
      </dx-tree-list>
    </div>
  </div>
</div>
